export const initialColors = {
  primary:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--primary')
      .trim() || '#000000',
  accent:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--accent')
      .trim() || '#00be9c',
  dark_7:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--dark_7')
      .trim() || '#2C2829',
  dark_6:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--dark_6')
      .trim() || '#363132',
  dark_5:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--dark_5')
      .trim() || '#3F3A3A',
  dark_4:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--dark_4')
      .trim() || '#484343',
  dark_3:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--dark_3')
      .trim() || '#524D4D',
  dark_2:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--dark_2')
      .trim() || '#5D5756',
  dark_1:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--dark_1')
      .trim() || '#676161',
  core:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--core')
      .trim() || '#736D6D',
  light_1:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--light_1')
      .trim() || '#807A7A',
  light_2:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--light_2')
      .trim() || '#8D8787',
  light_3:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--light_3')
      .trim() || '#9B9595',
  light_4:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--light_4')
      .trim() || '#AAA4A4',
  light_5:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--light_5')
      .trim() || '#B8B4B4',
  light_6:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--light_6')
      .trim() || '#C8C5C5',
  light_7:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--light_7')
      .trim() || '#FFFFFF',
  light_7_rgb:
    getComputedStyle(document.documentElement)
      .getPropertyValue('--light_7_rgb')
      .trim() || '255, 255, 255',
};
